import {
  IWidgetInstance,
  WidgetTemplateSharedProps,
} from "@src/interface/Widget";

export type ILoadWidgetProps = IWidgetInstance &
  WidgetTemplateSharedProps & {
    componentName?: string | null;
    template?: string | null;
    instance?: object | null;
    className?: string;
  };

export enum IStoreVisibility {
  NO_LIMITATION = "0",
  LIMITED_TO_SELECTED_STORE = "1",
  EXCLUDED_TO_SELECTED_STORE = "2",
}
export type IStoreVisibilityParams = {
  all_store?: IStoreVisibility;
  show_if_no_store?: string;
  stores?: string[];
};
